module.exports = __webpack_public_path__ + "img/744.d0153c3a.jpg";